import url,{BaseURL} from './url.js'

const AppConsts= {
    appBaseUrl: BaseURL,
    remoteServiceBaseUrl:url,
	authTokenKey: "auth_token_key",
	goodsListKey: "goodsList_key"
}
export default AppConsts